module.exports = __webpack_public_path__ + "media/components/country-flag/static/sr-98e0555a35e0bd7f8628b81d3400bf50.svg";